jQuery(document).ready(function ($) {
    $(".banner-home").slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 3000,
        fade: true,
        cssEase: "ease-in-out",
    });
});
